import React from 'react';
import { ClockIcon, ListOrderedIcon, PuzzleIcon, RotateCcwIcon, TriangleAlertIcon, WrenchIcon } from 'lucide-react';
import { disciplines, painPoints } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
const icons = [ListOrderedIcon, ClockIcon, PuzzleIcon, WrenchIcon, TriangleAlertIcon, RotateCcwIcon];
export function PainPoints() {
  return <section className="w-full bg-white px-5 py-16 md:py-24" data-id="element-256" data-mp="2hj6vrnl0furm">
      <div className="mx-auto max-w-5xl" data-id="element-257" data-mp="2clnh4mkehfz5">
        <SectionHeading title="Does any of this sound familiar?" sub="If you answer YES to even one of these, I created this system for you." data-id="element-258" data-mp="2cklxhtpbjl5t" />

        <ul className="mx-auto mt-10 grid max-w-4xl gap-x-10 gap-y-6 md:grid-cols-2" data-id="element-259" data-mp="2mjbdfgxnmvjf">
          {painPoints.map((text, i) => {
          const Icon = icons[i];
          return <li key={text} className="flex items-start gap-4 border-b border-navy/10 pb-6" data-id="element-260" data-mp="s6217hdq4vxh" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sky-pale text-navy-700" data-id="element-261" data-mp="1n83ds1p5m0l0">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-262" data-mp="1s7y4o58xiq62" />
                </span>
                <p className="text-[17px] leading-relaxed text-navy" data-id="element-263" data-mp="1x5pumtq0k27m">{text}</p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-264" data-mp="21yakxl9pnx6e">
          <p className="font-serif text-2xl font-bold text-navy md:text-3xl" data-id="element-265" data-mp="26wkho0b335u4">And it shouldn’t have to be that way.</p>
          <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-266" data-mp="2aw32kw2wngwy">
            The problem isn’t necessarily that you need more information. The problem is that most orthodontic education teaches
            individual concepts separately:
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-267" data-mp="lig5jbid57mg">
            {disciplines.map(d => <li key={d} className="rounded-full bg-navy px-4 py-2 text-sm font-bold text-white" data-id="element-268" data-mp="qhayh6a1ocka">
                {d}
              </li>)}
          </ul>
          <p className="mt-5 text-[17px] leading-relaxed text-muted" data-id="element-269" data-mp="iixt5106tex8">
            But when the patient is sitting in front of you, you have to connect all of those pieces yourself.{' '}
            <strong className="text-navy" data-id="element-270" data-mp="sgc80w6gpvnf">That’s exactly what Ortho Treatment Map™ is designed to help you do.</strong>
          </p>
        </div>

        <div className="mt-12" data-id="element-271" data-mp="11f7em9df57r9">
          <CtaButton label="I want a system for planning my cases" data-id="element-272" data-mp="11eeevscvniim" />
        </div>
      </div>
    </section>;
}